import SrText from "./SrText.vue";

SrText.install = function(Vue) {
  Vue.component(SrText.name, SrText);
};

export default SrText;


// WEBPACK FOOTER //
// ./packages/SrText/index.js